import { Component, inject } from '@angular/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import {
  LetpensiondkMedarbejdereListComponent
} from '@features/letpensiondk/letpensiondk-medarbejdere/letpensiondk-medarbejdere-list/letpensiondk-medarbejdere-list.component';
import {
  LetpensiondkMedarbejdereDetailComponent
} from '@features/letpensiondk/letpensiondk-medarbejdere/letpensiondk-medarbejdere-detail/letpensiondk-medarbejdere-detail.component';
import { MedarbejdereService } from '@features/letpensiondk/letpensiondk-medarbejdere/medarbejdere.service';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-letpensiondk-medarbejdere',
  imports: [
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    LetpensiondkMedarbejdereListComponent,
    LetpensiondkMedarbejdereDetailComponent,
    Button,
  ],
  templateUrl: './letpensiondk-medarbejdere.component.html',
  styleUrl: './letpensiondk-medarbejdere.component.css'
})
export class LetpensiondkMedarbejdereComponent {
  medarbejdereService = inject(MedarbejdereService);
}
